const STORAGE_KEY = 'takhfifan_auth';

export function setLocalAuth({ auth, uuid }) {
	const payload = {
		auth,
		uuid,
	};
	localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function getLocalAuth() {
	const raw = localStorage.getItem(STORAGE_KEY);
	if (!raw) return null;
	try {
		return JSON.parse(raw);
	} catch (e) {
		localStorage.removeItem(STORAGE_KEY);
		return null;
	}
}

export function getLocalToken() {
	const auth = getLocalAuth();
	return auth?.auth?.activeBusinessToken ?? null;
}

export function getMasterToken() {
	const auth = getLocalAuth();
	return auth?.auth?.masterToken ?? null;
}

export function getId() {
	const auth = getLocalAuth();
	return auth?.auth?.businessId ?? null;
}
